import { render, staticRenderFns } from "./BillsList.vue?vue&type=template&id=bbaeb302&scoped=true"
import script from "./BillsList.vue?vue&type=script&lang=js"
export * from "./BillsList.vue?vue&type=script&lang=js"
import style0 from "./BillsList.vue?vue&type=style&index=0&id=bbaeb302&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaeb302",
  null
  
)

export default component.exports